import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import GeneralNewsTable from './GeneralNewsTable';
import YearCombo from '../common/YearCombo';
import MonthCombo from '../common/MonthCombo';
import { getBaseName } from '../common/Utils';

class NewsListPanel extends Component {
    
    constructor(props) {
        super(props);

        const { history } = this.props;
        
        if ( typeof(history.location.state) === 'undefined' ) {
            history.replace(history.location.path,{pageNo:0});
        }

        this.state = {
            query: {
                lang: props.match.params.lang,
                category: props.category,                
                year: "all",
                month: "all",
                pageNo: history.location.state['pageNo'],
                pageSize: 20,
                isLoading: true,
                errors: null,
                items: null,
                total: -1
            }
        };
    }

    mergeQuery(updates) {
        let state = this.state;
        let mergedQuery = Object.assign({},state.query,updates);
        state.query = mergedQuery;
        return state;
    }

    async refreshTable() {
        const apiUrl = `${getBaseName()}/api/news/search`;
        const { query } = this.state;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        }


        let updates = {};
        try {            
            window.scrollTo(0, 0);
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                //console.log(result);

                updates = {
                    items: result.items,
                    total: result.total,
                    errors: null
                };
            } else {

            }
        } catch (error) {
            //console.log(error);
            updates = {
                errors: error
            };
        } finally {
            updates['isLoading'] = false;
            const state = this.mergeQuery(updates);
            this.setState(state);
        }

    }

    componentDidMount() {
        setTimeout(() => {this.refreshTable()},1500);
        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }
    }

    handleYearChange(e) {
        e.preventDefault();
        const updates = { year: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handleMonthChange(e) {
        e.preventDefault();
        const updates = { month: e.target.value, pageNo: 0, isLoading: true };
        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }

    handlePageChange(data) {
        const updates = { pageNo: data.selected, isLoading: true };

        const { history } = this.props;
        history.replace(history.location.path,{pageNo:data.selected});

        const state = this.mergeQuery(updates);
        this.setState(state);
        this.refreshTable();
    }
    
    render() {
        const { t } = this.props;
        const { query } = this.state;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;


        let category = this.props.category;
        category = (category === undefined)?"all":category;        

        var footerNote;
        if(category === "all"){
            footerNote = "display";
        }
        else{
            footerNote = "displaynone";
        }

        return (
            <div style={{display:query.isLoading?"none":"block"}}>
                <Helmet>
                    <title>{t(`${category}.content.title`)} | {t('common:sfc')}</title>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>

                <div className="headline">
                    {t(`${category}.content.title`)}
                </div>
                <div dangerouslySetInnerHTML={{ __html: t(`${category}.content.description`)}}></div>
                <br/>
                <div className="date-filter">
                    <MonthCombo
                        month={this.state.query.month}
                        handleMonthChange={this.handleMonthChange.bind(this)}/>&nbsp;
                    <YearCombo
                        startYear={1996}
                        year={this.state.query.year}
                        handleYearChange={this.handleYearChange.bind(this)}/>
                </div>
                <GeneralNewsTable 
                    category={query.category} items={query.items} 
                    pageNo={query.pageNo} pageSize={query.pageSize} total={query.total}
                    handlePageChange={this.handlePageChange.bind(this)}/>

                <br/>
                <div className={footerNote}>
                    <p>{t('enforcement.footnotes.header')}</p>
                    <ol>
                        <li>{t('enforcement.footnotes.newsnote-1')}
                            <ol style={{"listStyleType" : "lower-alpha"}}>
                                <li>{t('enforcement.footnotes.newsnote-1a')}</li>
                                <li>{t('enforcement.footnotes.newsnote-1b')}</li>
                                <li>{t('enforcement.footnotes.newsnote-1c')}</li>
                            </ol>
                            {t('enforcement.footnotes.newsnote-1x')}
                        </li>
                        <li dangerouslySetInnerHTML={{__html:t('enforcement.footnotes.newsnote-2')}}></li>
                        <li dangerouslySetInnerHTML={{__html:t('enforcement.footnotes.newsnote-3')}}></li>
                    </ol>
                </div>
            </div>
        );
    }
}

export default withRouter(withTranslation()(NewsListPanel));